import { FormGroup } from '@angular/forms';

export function ConfirmPassword(
  controlName: string,
  matchingControlName: string
) {
  return (formGroup: FormGroup): { invalid: boolean } | null => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return null;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
      return { invalid: true };
    }

    matchingControl.setErrors(null);
    return null;
  };
}
